import OfferTargetBlock from './OfferTargetBlock';

export default OfferTargetBlock;
